module.exports = __webpack_public_path__ + "static/media/step-5.e2a8fb1e.png";